/*
 * @Author: jean
 * @LastEditors: Please set LastEditors
 * @Description:
 * @Date: 2021-12-8 14:53:23
 * @LastEditTime: 2023-10-20 14:34:01
 * @FilePath: /yft-b2c-web-h5/src/widget/Accoumulate/AccoumulateServ.js
 */
import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取累积制展示信息
   */
  static getCardTypeDetail(id) {
    return Request({
      url: `user/info/getCardTypeDetail/${id}`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  /**
   * 获取累积制展示信息
   */
  static submitTapUpdate(status) {
    return Request({
      url: `user/info/accumulateUserInfo/${status}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/widget/Accoumulate/AccoumulateServ.js